module.exports = __webpack_public_path__ + "img/Ekwateur_120X35.9dc54b54.png";